import { Heading } from "Components/Heading";
import { useDocumentTitle } from "Components/Hooks";
import React from "react";
import { NotificationProps } from "SharedConstants/Schema";
import { DashboardLink, HomepageLink } from "./HomepageLink";

export function Notification(
  props: NotificationProps & {
    children?: React.ReactNode;
  },
) {
  useDocumentTitle(`Notification - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading {...props} title={props.Heading} />
      <div>{props.Body || props.children}</div>
      {props.IsAuthenticated && <DashboardLink />}
      <div style={{ marginTop: "1em" }}>
        <HomepageLink {...props.HomepageLinkProps} />
      </div>
    </>
  );
}
